<template>
  <b-form-group
    :label="changePositionName(position) "
    label-cols-lg="3"
    class="text-lg-right"
    :label-for="position.name"
    v-if="position"
  >
    <b-form-select
      :value="selected.user_id"
      @change="onChange"
      :options="subcontractors"
      :size="size"
    >
      <template v-slot:first>
        <b-form-select-option :value="null">--</b-form-select-option>
        <b-form-select-option :value="0" v-if="position.name !== 'extra'"
          >Nie dotyczy</b-form-select-option
        >
        <b-form-select-option
          :value="trashed.value"
          v-if="trashed.value"
          :disabled="true"
          >{{ trashed.text }} (usunięty)</b-form-select-option
        >
      </template>
    </b-form-select>
  </b-form-group>
</template>
<script>
import { changePositionName } from "@/utils/index";

export default {
  name: "ConstructionSubcontractorsSelect",
  props: {
    withphone: { type: Boolean, default: false },
    position: Object,
    selected: Object,
    index: Number,
    size: { type: String, default: "" },
  },
  data() {
    return {
      subcontractors: [],
      trashed: { value: false, text: "" },
    };
  },
  mounted() {
    // position.subcontractors
    this.$_.each(this.position.subcontractors, (item) => {
      this.subcontractors.push({
        value: item.value,
        text:
          item.text +
          (this.withphone === true && item.phone ? ", tel: " + item.phone : ""),
      });
    });

    let option = this.$_.find(this.subcontractors, (o) => {
      return o.value === this.selected.user_id;
    });
    if (this.$_.isUndefined(option) === true) {
      this.trashed = {
        value: this.selected.user_id,
        text: this.selected.firstname + " " + this.selected.lastname,
      };
    }
  },
  methods: {
    changePositionName: changePositionName,
    onChange(newValue) {
      this.$emit("update", this.selected, newValue);
    },
  },
};
</script>
